import { z } from 'zod'

/**
 * GET /usage/today response — per D-40.
 *
 * - `budget` is the free-tier daily TomTom cap (fixed: 2500).
 * - `percent_used` is an integer 0..100.
 * - `warning` trips at 80% (2000 txns) per D-41.
 */
export const UsageTodaySchema = z.object({
  date: z.string(),
  total: z.number().int().nonnegative(),
  by_endpoint: z.record(z.string(), z.number().int().nonnegative()),
  budget: z.literal(2500),
  percent_used: z.number().int().min(0).max(100),
  warning: z.boolean(),
})
